import { PureComponent } from 'react';
import { getDateTime } from '@sda/utils/date';
import { getDisplayName } from '@sda/utils/string';
import { bootIntercom, updateIntercom } from '@client/intercom';

export class Intercom extends PureComponent {
  static trigger = (event, data) => {
    if (window.Intercom) {
      window.Intercom('trackEvent', event, data);
    }
  };

  static identify = (user, profile = null) => {
    if (window.Intercom && user && user.id && user.intercomHash) {
      let company = null;

      if (profile && profile.id) {
        company = {
          company_id: profile.id,
          created_at: profile.createdAt || null,
          name: profile.name || '',
          size: profile.numCollaborators || 1,
          website: profile.websiteUrl || '',
          profileType: profile.profileType || '',
          city: profile.city || '',
          region: profile.region || '',
          country: profile.country || '',
          hasFinishedShow: profile.hasFinishedShow || false,
          instagramUrl: profile.instagramUrl || '',
          facebookUrl: profile.facebookUrl || '',
          twitterUrl: profile.twitterUrl || '',
          numReviews: profile.numReviews,
          score: profile.score || 0,
          bandcampUri: profile.bandcampUri || '',
          soundcloudUri: profile.soundcloudUri || '',
          spotifyUri: profile.spotifyUri || '',
          youtubeUri: profile.youtubeUri || '',
          vimeoUri: profile.vimeoUri || '',
        };

        if (profile.profileType === 'venue') {
          // Let's just hard-code these because why not
          // TODO: Don't do this
          let venueTypeString = 'Unspecified';

          if (profile.venueType === 'etqYZaqjjddBMMuoakkj') {
            venueTypeString = 'Personal Residence';
          } else if (profile.venueType === 'Z3C4XMZDbLx9vUDcQ9g3') {
            venueTypeString = 'Community Space';
          } else if (['3OE0rY8nvV7PRkrsyt7X', 'I62gPdB0W1580Mf222fe', 'LmYocn66xBBleOA4RcTQ'].includes(profile.venueType)) {
            venueTypeString = 'Commercial Space';
          }

          company = {
            ...company,
            capacity: profile.capacity || 0,
            exactCapacity: profile.exactCapacity || 0,
            hasBillet: profile.hasBillet || false,
            hasGreenRoom: profile.hasGreenRoom || false,
            hasInstruments: profile.hasInstruments || false,
            hasMerchSpace: profile.hasMerchSpace || false,
            hasPA: profile.hasPA || false,
            hasParking: profile.hasParking || false,
            hasPets: profile.hasPets || false,
            isAccessible: profile.isAccessible || false,
            isPresenter: profile.isPresenter || false,
            venueType: venueTypeString,
          };
        } else {
          company = {
            ...company,
            compiledAddress: profile.compiledAddress || '',
            hasPetAllergy: profile.hasPetAllergy || false,
            isRejected: profile.isRejected || false,
            requiresBillet: profile.requiresBillet || false,
            requiresFood: profile.requiresFood || false,
            requiresGreenRoom: profile.requiresGreenRoom || false,
            requiresPA: profile.requiresPA || false,
          };
        }
      }

      updateIntercom({
        ...(company && { company }),
        email: user.email,
        user_id: user.uid,
        created_at: user.createdAt,
        name: getDisplayName(user),
        last_request_at: getDateTime().toSeconds(),
        acceptsGDPR: !!user.acceptsGDPR,
        user_hash: user.intercomHash || '',
        hasVenue: user.hasVenue || false,
        hasArtist: user.hasArtist || false,
        hasPresenter: user.hasPresenter || false,
        boughtTicket: user.boughtTicket || false,
        numShows: user.numShows || 0,
        intent: user.intent || 'unknown',
      });
    }
  };

  componentDidMount() {
    const {
      showIntercom, isMobile, hasProfile, hasLeftAlignedIntercom,
      hideLauncher,
    } = this.props;

    /* eslint-disable */
    //Set your APP_ID
    const APP_ID = process.env.INTERCOM_APP_ID;

    (function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/' + APP_ID; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();
    /* eslint-enable */

    bootIntercom(!hasProfile || isMobile || hideLauncher);

    if (showIntercom) {
      window.Intercom('show');
    }

    if (hasLeftAlignedIntercom) {
      updateIntercom({
        alignment: hasLeftAlignedIntercom ? 'left' : 'right',
        vertical_padding: hasLeftAlignedIntercom ? 80 : 20,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {
      showIntercom, isMobile, hasProfile, hasLeftAlignedIntercom,
      hideLauncher,
    } = this.props;

    if (showIntercom) {
      window.Intercom('show');
    }

    if (prevProps.isMobile !== isMobile || prevProps.hasProfile !== hasProfile || prevProps.hideLauncher !== hideLauncher) {
      bootIntercom(!hasProfile || isMobile || hideLauncher);
    }

    if (prevProps.hasLeftAlignedIntercom !== hasLeftAlignedIntercom) {
      updateIntercom({
        alignment: hasLeftAlignedIntercom ? 'left' : 'right',
        vertical_padding: hasLeftAlignedIntercom ? 80 : 20,
      });
    }
  }

  componentWillUnmount() {
    window.Intercom('shutdown');
  }

  render() {
    return null;
  }
}
